import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import ScrollBehavior from "scroll-behavior";
import get from "lodash/get";

import SocialShare from "./social-share";
import StateStorage from "../../../lib/scroll/state-storage";

import ShellPage from "webapp-common-ui/src/components/shell-page";
import GlobalNav from "webapp-common-ui/src/components/global-nav";
import GlobalFooter from "webapp-common-ui/src/components/global-footer";
import GlobalModal from "webapp-common-ui/src/components/global-modal/container";
import { openGlobalModal } from "webapp-common-ui/src/actions/global-modal-actions";

import { getSiteRoot } from "../../reducers";

import CssProvider from "webapp-common-ui/src/components/css-provider";
import css from "../styles.scss";
import { GlobalWrapper, GlobalChild } from "./styles";


@withRouter
@connect(
  (store) => ({
    siteRoot: getSiteRoot(store),
    messages: store.messages,
    options: store.options,
    user: store.user,
  }),
  {
    openGlobalModal,
  }
)
export default class SocialShareApp extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  componentWillMount() {
    const scrollStateStorage = new StateStorage(this.props.history);

    scrollStateStorage.clearStorage(); // clear scrolls on page load

    this.scrollBehavior = new ScrollBehavior({
      addTransitionHook: this.props.history.listen,
      stateStorage: scrollStateStorage,
    });
  }

  componentWillUpdate(nextProps) {
    if (nextProps.history && nextProps.history.action !== "POP") {
      return;
    }

    if (this.props.location.pathname === nextProps.location.pathname) {
      return;
    }
  }

  render() {
    const theme = get(this.props, "options.siteContext.domainToken", "");

    const displayGlobals = theme === "tm";
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    const navProps = {
      scrollThreshold: 1,
      disableBackground: true,
      openModal: this.props.openGlobalModal,
      language: get(this.props, "options.siteContext.language", "en-us"),
      sites: {
        tm: get(this.props, "options.siteContext.desktopSite", ""),
        my: get(this.props, "options.siteContext.desktopMyTmSite", ""),
        iccp: get(this.props, "options.siteContext.desktopIccpSite", ""),
        help: get(this.props, "options.siteContext.desktopHelpSite", ""),
      },
    };

    const footerProps = {
      language: get(this.props, "options.siteContext.language", "en-us"),
      sites: {
        tm: get(this.props, "options.siteContext.desktopSite", ""),
        my: get(this.props, "options.siteContext.desktopMyTmSite", ""),
        help: get(this.props, "options.siteContext.desktopHelpSite", ""),
      },
    };

    let content = (
        <SocialShare scrollBehavior={this.scrollBehavior} />
    );

    return (
      <CssProvider css={css}>
        <GlobalWrapper isIE11={isIE11}>
          {displayGlobals && <GlobalNav {...navProps} />}
          <GlobalChild isIE11={isIE11}>
            <ShellPage {...this.props} className={css.shareListingShellPage}>
              {content}
            </ShellPage>
          </GlobalChild>
          {displayGlobals && (
            <React.Fragment>
              <GlobalFooter {...footerProps} />
              <div id="modal-root" />
            </React.Fragment>
          )}
          <GlobalModal css={css} />
        </GlobalWrapper>
      </CssProvider>
    );
  }
}
